import { render, staticRenderFns } from "./MyStoreView.vue?vue&type=template&id=47cd1b81&lang=pug"
import script from "./MyStoreView.vue?vue&type=script&lang=js"
export * from "./MyStoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports